@if(isInitialized){
<form [formGroup]="getFormGroup()">
  <div class="item rounded freight-payer-grid p-2">
    <div class="row">
      <div class="p-2">
        <div class="mb-2 mogo-header-2 text-start p-2 border-bottom">
          To Location
        </div>
      </div>
    </div>
    <div class="row mb-1 m-2">
      <app-address-picker [formGroup]="getFormGroup()" label="To Address" [showPreciseLocationOptions]="true" preciseLocationLabel="To Location"></app-address-picker>
    </div>
    <div formGroupName="contact">
      <div class="row mb-1 m-2">
        <label class="col-3 mt-2 mogo-label text-start mogo-bold" for="required-completion-date-input">Contact:</label>
        <div class="col-9">
          <input id="customer-reference-input" type="text" class="form-control required" formControlName="name"
            placeholder="Contact Name" />
        </div>
      </div>
      <div class="row mb-1 m-2">
        <label class="col-3 mt-2 mogo-label text-start mogo-bold" for="required-completion-date-input">Phone:</label>
        <div class="col-9">
          <input id="customer-reference-input" type="text" class="form-control required" formControlName="phone"
            placeholder="Phone #" />
        </div>
      </div>
      <div class="row mb-1 m-2">
        <label class="col-3 mt-2 mogo-label text-start mogo-bold" for="required-completion-date-input">Email:</label>
        <div class="col-9">
          <input id="customer-reference-input" type="text" class="form-control required" formControlName="email"
            placeholder="Email" />

            @if(getFormGroup().get('contact')?.get('email')?.invalid && getFormGroup().get('contact')?.get('email')?.touched){
              <div class="text-start">
                <small class="text-danger">Please enter a valid email address</small>
              </div>
            }
        </div>
      </div>
    </div>
  </div>

</form>
}
